import React from 'react';
import { GiftIcon, BookOpenIcon, CheckCircleIcon, ShieldCheckIcon, ChevronDownIcon, ArrowRightIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: "Masterclass Técnica 'Cero Fallos'",
    value: 27,
    desc: 'Todos los secretos para que tus flanes salgan perfectos siempre. Conservación, texturas, solución de errores comunes. Nunca más tirarás una tanda.',
    emoji: '🎓'
  }, {
    num: 2,
    title: "Kit de Marca 'Efecto Boutique'",
    value: 27,
    desc: 'Cómo presentar tus flanes para que parezcan de pastelería premium y puedas cobrar el doble. Etiquetas, packaging y presentación paso a paso.',
    emoji: '✨'
  }, {
    num: 3,
    title: 'La Calculadora Anti-Inflación',
    value: 19,
    desc: 'Herramienta para calcular costes y precios en segundos. Nunca más venderás sin saber exactamente cuánto ganas por cada flan.',
    emoji: '🧮'
  }, {
    num: 4,
    title: 'Medidas y Precios: Domina tus Números',
    value: 17,
    desc: 'Guía completa de cantidades para producir en volumen. Cuánto comprar, cuánto hacer y cómo organizarte para maximizar tu beneficio semanal.',
    emoji: '📊'
  }, {
    num: 5,
    title: "El Sistema 'Venta Segura'",
    value: 27,
    desc: 'Guiones de mensajes para vender sin sentirte pesada ni molesta. Cómo llenar tu agenda de pedidos desde el grupo del barrio, Instagram o Wallapop.',
    emoji: '💬'
  }, {
    num: 6,
    title: 'Plan de Arranque en 7 Días',
    value: 17,
    desc: 'Tu hoja de ruta exacta para pasar de cero a tu primera venta en una semana. Día a día, sin dudas, sin excusas.',
    emoji: '📅'
  }];
  const totalBonusValue = bonuses.reduce((sum, b) => sum + b.value, 0);
  const productValue = 37;
  const totalValue = productValue + totalBonusValue;
  const todayPrice = 17;
  const savings = totalValue - todayPrice;
  return <section className="relative py-8 md:py-20 px-4 bg-[#FDFAF5]" data-id="element-49">
      <div className="absolute top-0 left-0 w-full h-4 bg-gradient-to-b from-[#3D2B1F] to-transparent" data-id="element-50"></div>
      <div className="max-w-4xl mx-auto pt-4" data-id="element-51">
        {/* Header */}
        <div className="text-center mb-5 md:mb-12" data-id="element-52">
          <GiftIcon className="w-12 h-12 md:w-16 md:h-16 text-caramel-dark mx-auto mb-3" data-id="element-53" />
          <h2 className="md:text-5xl font-heading font-extrabold text-brown-dark text-[32px]" data-id="element-54">
            Todo lo que recibes hoy con tu acceso
          </h2>
          <p className="text-lg md:text-xl text-gray-700 mt-2 md:mt-4 font-medium leading-relaxed italic" data-id="element-55">
            (para que no solo domines la receta… sino que VENDAS)
          </p>
        </div>

        <div className="space-y-3 md:space-y-6" data-id="element-56">
          {/* Product Principal Card */}
          <div className="bg-cream rounded-[10px] p-4 md:p-8 shadow-lg border-2 border-caramel flex flex-col md:flex-row gap-4 md:gap-6 items-start relative overflow-hidden" data-id="element-57">
            <div className="absolute top-0 right-0 bg-brown-dark text-white text-[10px] md:text-xs font-bold px-3 py-1 md:px-4 md:py-1.5 rounded-bl-lg tracking-wider" data-id="element-58">
              PRODUCTO ESTRELLA
            </div>

            <div className="bg-caramel w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-59">
              <BookOpenIcon className="w-6 h-6 md:w-8 md:h-8 text-white" data-id="element-60" />
            </div>

            <div className="flex-1" data-id="element-61">
              <h3 className="text-lg md:text-2xl font-heading font-bold text-brown-dark mb-1.5 pr-24 md:pr-28" data-id="element-62">
                Las 30 Recetas de Flanes que Facturan
              </h3>
              <p className="text-sm md:text-base text-gray-600 font-medium mb-2" data-id="element-63">
                30 recetas irresistibles organizadas por rentabilidad. Cada una
                con ingredientes, tiempos, cantidades para producción en serie y
                precio de venta recomendado. Las que mis clientas me sacan de
                las manos.
              </p>
              <div className="font-bold text-brown-dark text-base md:text-lg" data-id="element-64">
                Valor: $37
              </div>
            </div>
          </div>

          {/* Bonus Cards */}
          {bonuses.map((bonus, index) => {
          const isOdd = index % 2 === 0; // 0-indexed, so 0 is Bonus 1 (odd)
          const bgClass = isOdd ? 'bg-white' : 'bg-[#F5EDD8]';
          const badgeClass = isOdd ? 'bg-cta-green' : 'bg-[#5C3D2E]';
          return <div key={bonus.num} className={`${bgClass} rounded-[10px] p-4 md:p-8 shadow-[0_2px_8px_rgba(0,0,0,0.08)] border border-[#D4A853]/40 flex flex-col md:flex-row gap-4 md:gap-6 items-start relative overflow-hidden`} data-id="element-65">
                <div className={`absolute top-0 right-0 ${badgeClass} text-white text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-bl-lg`} data-id="element-66">
                  BONO #{bonus.num}
                </div>

                <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center flex-shrink-0 text-3xl md:text-4xl" data-id="element-67">
                  {bonus.emoji}
                </div>

                <div className="flex-1" data-id="element-68">
                  <h3 className="text-lg md:text-2xl font-heading font-bold text-brown-dark mb-1 pr-16 md:pr-20" data-id="element-69">
                    {bonus.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 font-medium mb-2" data-id="element-70">
                    {bonus.desc}
                  </p>
                  <div className="flex items-center gap-2 font-bold" data-id="element-71">
                    <span className="text-gray-400 line-through text-sm" data-id="element-72">
                      ${bonus.value}
                    </span>
                    <span className="text-success-green bg-green-50 px-2 py-0.5 rounded text-xs uppercase tracking-wider" data-id="element-73">
                      HOY GRATIS
                    </span>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Value Summary Box */}

        {/* Scroll indicator */}
        <div className="flex justify-center mt-5 md:hidden" data-id="element-74">
          <ChevronDownIcon className="w-6 h-6 text-caramel/40 animate-bounce" data-id="element-75" />
        </div>
      </div>
    </section>;
}